<nb-card class="survey-dialog">
  <nb-card-header>
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    نظرسنجی تارت
  </nb-card-header>
  <nb-card-body class="p-4" style="max-height: 600px;">
    <p class="intro p-4 mb-4" [innerHTML]="surveyDetails?.description"></p>
<!--    <iframe -->
<!--      [src]="surveyUrl" -->
<!--      width="100%" -->
<!--      height="500px" -->
<!--      style="border:none;">-->
<!--    </iframe>-->
    <div class="question-container pb-3 mb-3" [ngClass]="{'border-bottom':!isLast}" *ngFor="let question of surveyDetails?.questions;let isLast = last;">
      <p class="pt-2">{{question.title}}<span *ngIf="!isLast" style="color: #DD2828;margin-right: 5px;">*</span></p>
      <div style="width: 365px" *ngIf="question.questionType === 'Optional'">
        <nb-radio-group name="dataType" class="col-4 d-flex mb-1" [(ngModel)]="question.answer" (ngModelChange)="onAnswerChange()">
          <nb-radio data-testid="question-radio" *ngFor="let option of options" [ngClass]="{'active':question.answer===option}" class="conflict-columns col-6 pe-2" [value]="option">{{option}}</nb-radio>
        </nb-radio-group>
        <div class="question-range">
          <span>خیلی خوب</span>
          <span>خیلی بد</span>
        </div>
      </div>
      <ng-container *ngIf="question.questionType !== 'Optional'">
<!--        <div class="search-input px-2">-->
<!--          <textarea-->
<!--            [(ngModel)]="question.answer"-->
<!--            class="input textarea form-control"-->
<!--            rows="4"-->
<!--          ></textarea>-->
<!--        </div>-->
        <div class="col-12 mt-3 bg-white">
          <textarea
            rows="5"
            fullWidth
            nbInput
            [(ngModel)]="question.answer"
          ></textarea>
        </div>
      </ng-container>
    </div>
    <div class="question-footer">
      <button
        nbButton
        size="large"
        type="submit"
        (click)="onSubmit('submit')"
        [nbSpinner]="isLoading"
        [disabled]="isLoading || (validResponseCount !== answerCount)"
        [ngClass]="(validResponseCount === answerCount) ? 'submit-button':'submit-button-deactive'"
      >
        ارسال
      </button>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <nb-checkbox [(ngModel)]="dontShowAgain" (ngModelChange)="onSubmit('ignore')">عدم نمایش مجدد</nb-checkbox>
  </nb-card-footer>
</nb-card>
